import React from "react";
import { Grid } from "@material-ui/core";
import { Select } from "./Select";
import { TextField } from "./TextField";
import { InputLabel } from "./InputLabel";
import NumberFormatCustom from "./NumberFormat";
import Button from "./Button";
import { Radio } from "./Radio";
import { CheckBox } from "./CheckBox";
import { DatePicker } from "./DatePicker";
import { ComboBox } from "./Autocomplete";
import FreeSoloCreateOption from "./AutoCompleteWithAdd";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as YearDatepicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import TableSelect from "./TableSelect";
import _ from "lodash";
import { AutocompleteTable } from "./AutocompleteTable";
import { Autocomplete, TextField as MuiTextField } from "@mui/material";
import { useGlobalStyles } from "./globalStyles";

const Template = (props) => {
  const { payload, selectedQuotes } = props;
  const classes = useGlobalStyles();

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    const value = event.target.value;
    const decimalIndex = value.indexOf(".");

    if (
      (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) ||
      (charCode === 46 && value.includes(".")) ||
      (decimalIndex !== -1 && value.length - decimalIndex > 3)
    ) {
      event.preventDefault();
    }
  };

  const selectComponent = (v, i) => {
    switch (v.type) {
      case "input":
        return (
          <TextField
            key={i}
            {...v}
            inputProps={{ step: "0.001", pattern: "[0-9]*[.,]?[0-9]{0,3}" }}
          />
        );
      case "custom":
        return <React.Fragment key={i}>{v.component}</React.Fragment>;
      case "button":
        return <Button key={i} {...v} />;
      case "number":
        if (v.format) {
          <TextField
            label="react-number-format"
            value={props.value}
            onChange={props.onChange}
            onBlur={props.handleBlur}
            name={props.label}
            id="formatted-numberformat-input"
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
            variant="standard"
          />;
        }
        return (
          <TextField
            key={i}
            {...v}
            InputProps={{ pattern: "[0-9]*" }}
            type="number"
            onWheel={(event) => document.activeElement.blur()}
            onKeyPress={v.onKeyPress}

          />
        );
      case "float":
        return (
          <TextField
            key={i}
            {...v}
            type="number"
            onWheel={(event) => document.activeElement.blur()}
          />
        );
      case "file":
        return <TextField key={i} {...v} type="file" />;
      case "label":
        return (
          <InputLabel key={i} {...v}>
            {v.value}
          </InputLabel>
        );
      case "select":
        return <Select key={i} {...v} />;
      // case "selectMultiple":
      //   return <Select key={i} {...v} multiple value={Array.isArray(v.value) ? v.value : []} />;
      case "selectMultiple":
        return (
          // <Autocomplete
          //   key={i}
          //   {...v}
          //   multiple
          //   options={v.options || []}
          //   value={Array.isArray(v.value) ? v.value : []}
          //   getOptionLabel={(option) => {
          //     if (!option) return '';
          //     if (v.labelprop) {
          //       return option[v.labelprop] ? option[v.labelprop].toString() : '';
          //     }
          //     return option.label ? option.label : '';
          //   }}
          //   renderInput={(params) => (
          //     <MuiTextField
          //       {...params}
          //       variant="outlined"
          //       label={v.label}
          //       placeholder={v.placeholder}
          //       helperText={v.helperText}
          //       error={v.error}
          //       required={v.required}
          //     />
          //   )}
          //   onChange={(event, newValue) => v.onChange({ target: { value: newValue } })}
          // />
          <Autocomplete
            key={i}
            multiple
            options={v.options || []}
            value={Array.isArray(v.value) ? v.value : []}
            getOptionLabel={(option) => option.label || ""}
            renderInput={(params) => (
              <MuiTextField
                {...params}
                variant="outlined"
                label={v.label}
                placeholder={v.placeholder}
                helperText={v.helperText}
                error={v.error}
                required={v.required}
              />
            )}
            onChange={(event, newValue) =>
              v.onChange({ target: { value: newValue } })
            }
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            renderOption={(props, option) => (
              <li
                {...props}
                key={option.value}
                style={{
                  backgroundColor: selectedQuotes.some(
                    (selected) => selected.value === option.value
                  )
                    ? "#e0e0e0"
                    : "inherit",
                }}
              >
                {option.label}
              </li>
            )}
          />
        );

      case "selectMultipleCreate":
        return (
          <Autocomplete
            key={i}
            {...v}
            multiple
            options={v.options || []}
            value={Array.isArray(v.value) ? v.value : []}
            getOptionLabel={(option) => {
              if (!option) return "";
              if (v.labelprop) {
                return option[v.labelprop]
                  ? option[v.labelprop].toString()
                  : "";
              }
              return option.label ? option.label : "";
            }}
            renderInput={(params) => (
              <MuiTextField
                {...params}
                variant="outlined"
                label={v.label}
                placeholder={v.placeholder}
                helperText={v.helperText}
                error={v.error}
                required={v.required}
              />
            )}
            onChange={(event, newValue) =>
              v.onChange({ target: { value: newValue } })
            }
          />
        );
      case "radio":
        return <Radio key={i} {...v} />;
     
      case "checkbox":
        return <CheckBox key={i} {...v} />;
      case "datePicker":
        return <DatePicker key={i} {...v} />;
      case "autocomplete":
        return <ComboBox key={i} {...v} />;
      case "autocompletewithtable":
        return <AutocompleteTable key={i} {...v} />;
      case "autocompleteAdd":
        return <FreeSoloCreateOption key={i} {...v} />;
      case "yearDatepicker":
        return (
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            className="yeardate1"
            sx={{ width: "100%" }}
          >
            <DemoContainer
              components={["DatePicker"]}
              className="yeardate2"
              sx={{ width: "100%" }}
            >
              <YearDatepicker
                key={i}
                {...v}
                value={_.isEmpty(v.value) ? null : dayjs(v.value)}
                views={["year", "month", "day"]}
                className="yeardate3"
                format={"DD/MM/YYYY"}
              />
            </DemoContainer>
          </LocalizationProvider>
        );
      case "tableSelect":
        return <TableSelect key={i} {...v} />;
      case "inputDecimal":
        return (
          <TextField
            key={i}
            {...v}
            inputProps={{ step: "0.001", pattern: "[0-9]*[.,]?[0-9]{0,3}" }}
            onKeyPress={handleKeyPress}
            type="number"
          />
        );
      default:
        return null;
    }
  };

  //eslint-disable-next-line
  return (
    <Grid
      id="top-row"
      container
      spacing={props?.spacing ?? 2}
      direction="row"
      justifyContent={props.justify}
      alignItems={props.align}
    >
      {payload.map((v, i) => {
        if (v !== false) {
          if (v.type === "spacer") {
            return (
              <Grid
                key={i}
                item
                xs={12} 
                sm={3} 
                className={classes.visibleHidden}
              />
            );
          }
          return (
            <Grid
              item
              xs={v.xs || 12}
              sm={v.sm || 6}
              className="posrelative"
              style={{
                overflowWrap: "break-word",
                textTransform: "capitalize",
              }}
            >
              {selectComponent(v, i)}
              {v.isplusShow ? (
                <span className="pluspost" onClick={v.onClick}>
                  +
                </span>
              ) : null}
            </Grid>
          );
        }
      })}
    </Grid>
  );
};

export default Template;
